import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'

enum ModelTypes {
  PatientWithLatestVisit = 'patient-with-latest-visit',
}

enum ModelTypeNames {
  PatientWithLatestVisit = 'patientWithLatestVisit',
}

export interface PatientWithLatestVisitAttributes {
  firstName: string
  lastName: string
  visitTimestamp: number
  staffFirstName: string
  staffLastName: string
  timezone: string
  // starttimestamp: number
  // endtimestamp: number
  // resultStartTimestamp: number
  // resultEndTimestamp: number
}

export interface PatientWithLatestVisitSchema {
  id: string
  attributes: PatientWithLatestVisitAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.PatientWithLatestVisit]: {
      attributes: {
        firstName: { type: 'string' },
        lastName: { type: 'string' },
        visitTimestamp: { type: 'number' },
        timezone: { type: 'string' },
        staffFirstName: { type: 'string' },
        staffLastName: { type: 'string' },
      },
    },
  },
}

export interface GetPatientWithLatestVisitByIdDto {
  patientId: string
  startTimestamp: number
  endTimestamp: number
}

// export async function getPatientWithLastVisitQuery() {
//   const schema = new Schema(schemaDefinition)
//   const remote = await KC.getJsonApiRemoteResource(schema)
//   return remote
//     .query(q => {
//       console.log('Before calling find record for patient with last visit')
//       return q.findRecords(ModelTypes.PatientWithLastVisit)
//     })
//     .catch(() => {
//       console.log('fetch failed in patients with last visit')
//     })
// }

export async function getPatientWithLatestVisitByIdQuery(patient) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  console.log('Before calling find record for patient with latest visit', patient.patientId)
  return remote
    .query(q => q.findRecord({ type: ModelTypes.PatientWithLatestVisit, id: patient.patientId }))
    .catch(() => console.log('fetch failed in patient with latest visit', patient.patientId))
}
